<style lang="less">
.omItem {
  position: relative;
  top: 0;
  left: 0;
  border-left: 1px solid #e2e2e2;
  padding: 0.2rem 0 0 0.3rem;
  box-sizing: border-box;

  &::before {
    position: absolute;
    content: ' ';
    display: inline-block;
    font-size: 1px;
    border-radius: 50%;
    background: #e2e2e2;
    box-sizing: border-box;
    border: 1px solid #fff;
    top: 0.28rem;
    left: -0.1rem;
    width: 0.19rem;
    height: 0.19rem;
  }
  // &::after {
  //   content: " ";
  //   display: block;
  //   border-bottom: 1px solid #eaeaea;
  // }

  // .hr {
  //   margin-left: 0.125rem * 2;
  //   margin-right: 0.09375rem * 2;
  //   border-top: 1px solid #e0e0e0;
  //   height: 0.09375rem * 2;
  // }

  h3 {
    margin: 0;
    padding: 0 0.1rem 0.15rem 0rem;
    font-size: 0.32rem;
    color: #4c4c4c;
  }
}
.active {
  h3,
  .omAudio__duration {
    color: #3f8eed;
  }
  &.omItem {
    &::before {
      background: #4a94ed;
      border-color: #a8c9f0;
      border-width: 0.05rem;
      width: 0.25rem;
      height: 0.25rem;
      left: -0.13rem;
      top: 0.25rem;
    }
  }
}

.playing {
  .omAudio__player::before {
    background: url(../../assets/img/ico_audio_pause.png) 0 0 no-repeat;
    background-size: auto 100%;
  }
}

.omAudio {
  @height: 0.8rem;
  @width: 5rem;

  &::before,
  &::after {
    content: ' ';
    display: table;
  }

  &::after {
    clear: both;
  }

  &__player {
    border: 1px solid #ebebeb;
    position: relative;
    top: 0;
    left: 0;
    height: @height;
    width: @width;
    box-sizing: border-box;
    border-radius: @height / 2;
    background-image: linear-gradient(-180deg, #fff 0, #e2e2e2 100%);
    box-shadow: 0 2px 2px 0 rgba(175, 175, 175, 0.5);
    &:before {
      position: absolute;
      content: ' ';
      display: block;
      background: url(../../assets/img/ico_audio_play.png) 0 0 no-repeat;
      background-size: auto 100%;
      top: 50%;
      left: 0.3rem;
      width: 0.3rem;
      height: 0.3rem;
      margin-top: -0.14rem;
    }
  }
  &__link {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 0;
    display: block;
    width: 100%;
    height: 100%;
    span {
      display: block;
      width: 100%;
      height: 100%;
      visibility: hidden;
    }
  }
  &__progress {
    position: absolute;
    font-size: 1px;
    top: (@height - 0.03rem)/2;
    left: 0.6rem;
    right: 0.3rem;
    border-top: 1px solid #e2e2e2;
    visibility: hidden;
  }
  &__doneLine {
    position: absolute;
    top: -1px;
    left: 0;
    border-top: 1px solid #008ce9;
    display: inline-block;
  }
  &__doneCir {
    @size: 0.125rem;
    display: inline-block;
    box-sizing: border-box;
    position: absolute;
    top: -@size / 2;
    left: 0;
    width: @size;
    height: @size;
    border-radius: 50%;
    background: url('../../assets/img/ico_audio_progress_done.png') no-repeat;
    background-size: cover;
  }
  &__doneSecs {
    position: absolute;
    left: 0.3rem;
    bottom: 0rem;
    font-size: 0.18rem;
    line-height: 1.2em;
    height: 1.2em;
    color: #0d8deb;
    visibility: hidden;
  }

  &__duration {
    position: absolute;
    left: 100%;
    color: #959595;
    width: 0.7rem;
    line-height: @height;
    font-size: 0.24rem;
    text-align: left;
    padding-left: 0.1rem;
  }
  &__pubTime {
    color: #ddd;
    font-size: 0.2rem;
    line-height: 2.5;
    padding: 0 0 0.1rem 0.3rem;
  }
}
</style>
<template>
  <div
    v-if="oid > 0"
    :id="`js-audio--${oid}`"
    class="omItem clearfix"
    :class="{
      active: isActive,
      playing: isActive && isPlaying
    }"
  >
    <h3>{{ item.title }}</h3>
    <div class="omAudio">
      <div class="omAudio__player">
        <div class="omAudio__progress">
          <div
            class="omAudio__doneLine"
            :style="`width:${playProgress * 100}%;`"
          ></div>
          <div
            class="omAudio__doneCir"
            :style="`left:${playProgress * 100}%;`"
          ></div>
        </div>
        <div class="omAudio__doneSecs" v-if="isActive">{{ playSeconds }}s</div>
        <div class="omAudio__duration">
          60
          <sup>〃</sup>
        </div>
        <a class="omAudio__link" href="javascript:;" @click="play({ oid })">
          <span>{{ item.title }}</span>
        </a>
      </div>
      <div class="omAudio__pubTime">
        {{ item.publishtime || item.showDate }} 发布
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['item'],
  computed: {
    ...mapGetters('oneminute', [
      'curItem',
      'curOid',
      'playSwitch',
      'playProgress',
      'playSeconds'
    ]),
    oid() {
      const { item } = this
      return item && item.oid > 0 ? item.oid : 0
    },
    isActive() {
      const { curOid, oid } = this
      return oid > 0 && curOid === oid
    },
    isPlaying() {
      return this.isActive && this.playSwitch
    }
  },
  methods: {
    ...mapActions('oneminute', ['play'])
  }
}
</script>
